module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMZJREFUeNpiZEADWsvfCwCpBCCOB2IDNOkLQLwQiBdcixT8gCzBiGZIAJCaD8QCDPgByJBEoGEbMAwCGpIANYQUADJsAdwgqEvWM5AHAkEuY4SGyX0k7zQCJRrQvAzi1+PxpiITNGBxhgnUInwAHDkgF53HEjukggtMVDAEBAxYsAhihBExYcVErJWEwgoURv+p4DXiXUQosEkKIzxhtZBkF2EJK1CCXECNMAJnEUrDCF4CkGvQB6hLFsAEWEiNHVwFG0CAAQD000ilTLxE3AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/icon/internoticon.png
// module id = psWr
// module chunks = 1